/**
 * @desc: 提现利润
 * @created: 2020/6/19
 * @author: huli
 * @version: v1.0
 */

import request from '@/plugins/http'

export const getListData = params => {
  return request.get('/withdrawal/list', params)
}
